export default __webpack_public_path__ + "static/media/CustomerService.87ef6b46.png";